import { useNotification } from '@gohighlevel/ghl-ui';
export const useNotificationEvent = () => {
    const notification = useNotification();
    const sendNotification = (params) => {
        notification.create(Object.assign(Object.assign({}, params), { duration: params.duration || 5000 }));
    };
    const handleError = (error) => {
        console.error(error);
        sendNotification({
            type: 'error',
            title: error.response.data.message,
            description: error.response.data.errorMessage,
        });
    };
    return {
        sendNotification,
        handleError,
    };
};
